<span (mouseover)="onMouseover()" (mouseout)="onMouseout()" class="relative">
  @if (showIcon) {
    <svg class="icon" focusable="false">
      <use [attr.xlink:href]="iconHref" xlink:href=""></use>
    </svg>
  }
  <span [ngClass]="showHover ? 'show-hover' : 'hide-hover'">{{hoverText}}</span>
</span>
